import React, { useCallback, useState } from 'react';
import { both, cond, equals, path, pick, pipe, prop, T, zipObj } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import { Toggle } from 'js/components/common/Fields/Toggle';
import { componentService } from 'js/services/component.service';
import { useShowNotification } from 'js/components/common/Notifications';
import { usePortletTranslations, withPortlet } from 'js/components/system/Portlet';

import { getPlayerTags, updatePlayerTags } from './actions';
import { UNAUTHORIZED_NOTIFICATION } from './constants';

import style from './index.scss';

export const EMAIL_SMS = 'email+sms';
export const EMAIL = 'email';
export const SMS = 'sms';
export const DISABLED = 'disabled';

export const UnauthorizedNotificationBare = ({ data: { tags } = {} }) => {
    const t = usePortletTranslations();

    const initialState = pipe(
        path([0]),
        prop('value'),
        cond([
            [equals(EMAIL_SMS), () => [true, true]],
            [equals(EMAIL), () => [true, false]],
            [equals(SMS), () => [false, true]],
            [equals(DISABLED), () => [false, false]],
            [T, () => [true, false]]
        ]),
        zipObj([EMAIL, SMS])
    )(tags);

    const [email, setEmail] = useState(initialState.email);
    const [sms, setSms] = useState(initialState.sms);

    const onChangeEmail = event => setEmail(event.target.checked);
    const onChangeSms = event => setSms(event.target.checked);

    const showNotification = useShowNotification();

    const onSubmit = useCallback((event) => {
            const value = pipe(
                pick([EMAIL, SMS]),
                cond([
                    [both(prop(EMAIL), prop(SMS)), () => EMAIL_SMS],
                    [prop(EMAIL), () => EMAIL],
                    [prop(SMS), () => SMS],
                    [T, () => DISABLED]
                ])
            )({ email, sms });

            event.preventDefault();

            updatePlayerTags(value)
                .then(() => showNotification(getNotification({ t, type: 'success' })))
                .catch(() => showNotification(getNotification({ t, type: 'error' })));
        }, [sms, email, showNotification, t]);

    return (
        <form className={style.form} onSubmit={onSubmit}>
            <h3 className={style.title}>{t('description')}</h3>
            <Toggle
                label={t('label.email')}
                checked={email}
                className={style.email}
                onChange={onChangeEmail} />
            <Toggle
                label={t('label.sms')}
                checked={sms}
                className={style.sms}
                onChange={onChangeSms} />
            <div className={style.button}>
                <Button type="submit">{t('submit')}</Button>
            </div>
        </form>
    );
};

export const getNotification = ({ t, type }) => ({
    message: t(`request.${type}`),
    Icon: <Icon className={style.icon} type="contactUs" />
});

export const UnauthorizedNotification = withPortlet({
    forLoggedIn: true,
    fetch: getPlayerTags
})(UnauthorizedNotificationBare);

componentService.registerPageComponents({ [UNAUTHORIZED_NOTIFICATION]: UnauthorizedNotification });

